<li class="nav-item">
  <a (click)="onClick()" [routerLink]="nav.url" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active">{{nav.title}}</a>
</li>
